module.exports = __webpack_public_path__ + "assets/img/bg-btn.4c8989cc.png";